import { useAuthQuery } from 'features/common/apiUtils/queryHelper';
import { useGetSitecoreContextId } from 'features/context-ids/api/useGetSitecoreContextId';
import { environments } from 'features/context-ids/config';
import { TenantApplicationNode } from 'features/context-ids/types/types';
import { getDeploymentInfoSync } from 'features/context-ids/utils/regenerationValidation';
import { UseQueryResult } from 'react-query';
import { EnvironmentDetails } from '../models/environment.model';

export const useGetDeploymentInfo = (
  applicationsNodes: TenantApplicationNode[],
  contextId: string,
): { isContextLoading: boolean } & UseQueryResult<EnvironmentDetails> => {
  const { data: contextResponse, isLoading: isContextLoading } =
    useGetSitecoreContextId({
      sitecoreContextId: contextId,
    });
  const deploymentInfo = getDeploymentInfoSync(
    contextResponse?.resources,
    applicationsNodes,
  );
  const environmentId = deploymentInfo?.environmentId || '';

  const { url, queryKey, scope } = environments.environment;

  return {
    isContextLoading,
    ...useAuthQuery(
      queryKey(environmentId),
      async (axiosInstance) => {
        const response = await axiosInstance?.get<EnvironmentDetails>(
          url(environmentId),
        );

        return response?.data;
      },
      {
        enabled: !!deploymentInfo?.environmentId,
      },
      scope,
    ),
  };
};
